import styled from 'styled-components'

import { PremiumTicker } from '@root/entities/premium/ui/premium-ticker/premium-ticker'
import { FadeOverflow } from '@root/shared/ui-kit'

import type { CurrencyModel } from '@root/entities/currency'
import type { PremiumMetaModel } from '@root/entities/premium'

type PairTitleProps = {
  premiumInfo: PremiumMetaModel
  quote: CurrencyModel
  base: CurrencyModel
}

export const PairTickers: React.FC<PairTitleProps> = ({
  quote,
  base,
  premiumInfo,
}) => {
  return (
    <Root>
      <FadeOverflow inlineStart={0} inlineEnd={8}>
        <BaseTicker>
          <PremiumTicker premiumInfo={premiumInfo}>
            {quote.ticker}
          </PremiumTicker>
        </BaseTicker>
      </FadeOverflow>

      <Slash>/</Slash>
      <QuoteTicker>{base.ticker}</QuoteTicker>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto auto;
  align-items: center;
  gap: 2px;
`

const BaseTicker = styled(FadeOverflow)`
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;

  position: relative;
  overflow: hidden;
  white-space: nowrap;
`

const QuoteTicker = styled.div`
  color: var(--text-12);
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
`

const Slash = styled.div`
  color: var(--text-8);

  font-size: 14px;
  font-weight: 700;
`
